import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { optionalDateAsString } from "web_myplann/Shared/Validation/optionalDateAsString";
import { optionalPositiveInteger } from "web_myplann/Shared/Validation/optionalPositiveInteger";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import { z } from "zod";

export const getInvestmentValueFormSchema = (t: TranslateFunction) => {
	const positiveValueMessage = t(
		Resources.PortfolioDetail.InvestmentValue.positiveValue,
	);
	const maxMessage = t(Resources.Portfolio.AddShared.Validations.maxValue);
	const requiredMessage = t(Resources.Portfolio.AddShared.Validations.required);

	return z.object({
		value: z
			.number({
				required_error: requiredMessage,
				invalid_type_error: requiredMessage,
			})
			.int(positiveValueMessage)
			.gt(0, positiveValueMessage)
			.max(ValidationLimits.Amount.Max, maxMessage),
		invested: optionalPositiveInteger(ValidationLimits.Amount.Max, {
			positiveMessage: positiveValueMessage,
			maxMessage,
		}),
		date: optionalDateAsString(
			DateFormat.Iso,
			t(Resources.Portfolio.AddShared.Validations.dateInFuture),
		),
	});
};

export type InvestmentValueFormInput = z.input<
	ReturnType<typeof getInvestmentValueFormSchema>
>;
export type InvestmentValueFormOutput = z.output<
	ReturnType<typeof getInvestmentValueFormSchema>
>;
